import axios from "axios";

export class ApiService {
    //Pelanggan
    getTotalPelanggan = async () => {
        return await axios.get(`pelanggan/dashboardtotalpelanggan`);
    }

    getPelanggan = async (size, page) => {
        return await axios.get(`pelanggan?size=${size}&page=${page}`);
    }

    totalPelanggan = async () => {
        return await axios.get('pelanggan/total');
    }

    pelangganPerangkatActive = async () => {
        return await axios.get('pelanggan/perangkatactive')
    }

    //Perangkat Internal
    getAllPerangkat = async (pageNumber, size, params) => {
        return await axios.get(`perangkat/getall?page=${pageNumber}&size=${size}${params}`);
    }

    getPerangkatId = async (id) => {
        return await axios.get("perangkat/" + id);
    }

    editPerangkatId = async (id, data) => {
        return await axios.put("perangkat/edit/" + id, data);
    }

    hapusPerangkatId = async (id) => {
        return await axios.delete("perangkat/" + id);
    }

    downloadExcelPerangkat = async (totalPerPage, params) => {
        return await axios.get(`perangkat/exportexcell?totalPerpage=${totalPerPage}${params}`, { responseType: 'blob' });
    }

    uploadPerangkat = async (clientId, tglOnline, tglEmail, file, sat_id) => {
        let formData = new FormData();
        formData.append("file", file);
        return await axios.post(`perangkat/upload/${clientId}?tglOnline=${tglOnline}&tglEmail=${tglEmail}&sat_id=${sat_id}`, formData, {
            headers: {
                "Content-Type": "multipart/form-data",
            }
        });
    }

    getMts = async (params) => {
        return await axios.get("perangkat/mts?name=" + params);
    }

    getBatch = async (params) => {
        return await axios.get("perangkat/batch?name=" + params);
    }

    getStation = async (params) => {
        return await axios.get("perangkat/station?name=" + params);
    }

    getDuplikasi = async (page, params) => {
        return await axios.get(`duplikat-perangkat?size=10&page=${page}${params}`)
    }

    replace = async (body) => {
        return await axios.post(`perangkat/replace`, body);
    }

    gudangkan = async (body) => {
        return await axios.post(`perangkat/gudangkan`, body);
    }

    geserkan = async (body, idDuplikat) => {
        return await axios.post(`perangkat/geser?idDuplikat=${idDuplikat}`, body);
    }

    geserkanAll = async (body, idDuplikatArr) => {
        return await axios.post(`perangkat/geserall?idDuplikatArray=${idDuplikatArr}`, body);
    }

    exportExcelDuplikasi = async (params) => {
        return await axios.get(`duplikat-perangkat/exportexcel?${params}`, { responseType: 'blob' });
    }

    perangkatAktif = async () => {
        return await axios.get('perangkat/totalactive');
    }

    perangkatTahunOnline = async () => {
        return await axios.get('perangkatkominfo/activeeachyear');
    }

    perangkatRingkasan = async () => {
        return await axios.get('perangkat/summary');
    }

    getSatelite = async () => {
        return await axios.get('perangkat/getsatelite');
    }

    //Perangkat Postel(kominfo)
    downloadSertifikat = async (size, page, params) => {
        return await axios.get(`perangkatkominfo/exportSuket?page=${page}&size=${size}${params}`, { responseType: 'blob', headers: { "Content-Type": "application/zip" } })
    }

    downloadExcelPostel = async (params) => {
        return await axios.get(`perangkatkominfo/exportexcel?` + params.replace(/^&/, ''), { responseType: 'blob' })
    }

    getAllPerangkatPostel = async (size, pageNumber, params) => {
        return await axios.get(`perangkatkominfo/get?size=${size}&page=${pageNumber}` + params);
    }

    getNoRegPostel = async (params) => {
        return await axios.get("perangkatkominfo/getnoregistrasi?name=" + params);
    }

    getBatchPostel = async (params) => {
        return await axios.get("perangkatkominfo/getbatch?name=" + params);
    }

    getStationPostel = async (params) => {
        return await axios.get("perangkatkominfo/getearthstationname?name=" + params);
    }

    getQrCodePostel = async (code) => {
        return await axios.get("perangkatkominfo/getqrcodeid?code=" + code);
    }

    totalPerangkatKominfo = async () => {
        return await axios.get('perangkatkominfo/total');
    }

    getPostel = async (tanggal) => {
        return await axios.get('perangkatkominfo/getpostel?date=' + tanggal);
    }

    getPostelPy = async (tanggal) => {
        return await axios.get('perangkatkominfo/getpostel-python?date=' + tanggal);
    }

    getPostelProgress = async () => {
        return await axios.get('perangkatkominfo/getpostel-progress?t=' + Date.now());
    }

    //Gudang
    getAllGudang = async (data, size, pageNumber) => {
        return await axios.get(`gudang/getall?client=${data.client}&filterDate=${data.filterDate}&size=${size}&page=${pageNumber}&batch=${data.batch}&station=${data.station}&mts=${data.mts}`)
    }

    //Riwayat-Upload
    getRiwayatUpload = async (size, page, params = {}) => {
        return await axios.get("historiimport/getall", { params: { size, page, ...params }});
    }

    deleteRiwayatUpload = async (batch) => {
        return await axios.delete("historiimport/deletebybatch?batch=" + batch)
    }

    gudangkanBatch = async (batch) => {
        return await axios.post("perangkat/gudangkan/" + batch);
    }

    //Riwayat-Unit
    getRiwayatUnit = async (size, page, params) => {
        return await axios.get(`historiunit/getall?size=${size}&page=${page}&tglUpload=${params.tglUpload}&station=${params.station}&batch=${params.batch}`)
    }

    getRiwayatIdUnit = async (id) => {
        return await axios.get("/historiunit/" + id)
    }

    //User
    signin = async (username, password) => {
        return await axios.post("auth/signin", { "usernameOrEmail": username, "password": password });
    }

    //Laporan
    getLaporan = async (page, params) => {
        return await axios.get("report/get?size=10&page=" + page + "&stasiun=" + params.station + "&batch=" + params.batch + '&qrcodeid=' + params.qrcodeid + "&mts=" + params.mts + "&tanggalonline=" + params.tanggalonline + "&registrationdateStart=" + params.registrationdateStart + "&registrationdateEnd=" + params.registrationdateEnd + "&client=" + params.client)
    }

    exportExcelLaporan = async (size, page, params) => {
        return await axios.get('report/exportexcel?size=' + size + '&page=' + page + '&stasiun=' + params.station + '&batch=' + params.batch + '&qrcodeid=' + params.qrcodeid + '&mts=' + params.mts + '&tanggalonline=' + params.tanggalonline + "&registrationdateStart=" + params.registrationdateStart + "&registrationdateEnd=" + params.registrationdateEnd + "&client=" + params.client, { responseType: 'blob' })
    }
}